<template>
  <div class="min-h-screen bg-gray-50 py-12 px-4">
    <button @click="logout" class="logout-btn">
      Logout
    </button>
    <div class="max-w-7xl mx-auto flex gap-8">
      <AdminNav :activeTab="activeTab" :tabs="tabs" @tab-selected="activeTab = $event" />
      <div class="flex-1">
        <h1 class="text-3xl font-bold mb-8">Admin Dashboard</h1>
        <component :is="currentComponent" />
      </div>
    </div>
    
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import AdminNav from '../../components/admin/AdminNav.vue'
import AdminContacts from '../../components/admin/AdminContacts.vue'
import AdminHeader from '../../components/admin/AdminHeader.vue'
import AdminHero from '../../components/admin/AdminHero.vue'
import { logout } from '../../utils/api.js'

const tabs = [
  { label: 'Contacts', value: 'contacts', component: AdminContacts },
  { label: 'Header', value: 'header', component: AdminHeader },
  { label: 'Hero', value: 'hero', component: AdminHero }
]

const activeTab = ref(tabs[0].value)
const currentComponent = computed(() => {
  const tab = tabs.find(t => t.value === activeTab.value)
  return tab ? tab.component : null
})
</script>
